import { render, staticRenderFns } from "./PromoCodeFilter.vue?vue&type=template&id=d20026b2"
import script from "./PromoCodeFilter.vue?vue&type=script&lang=ts"
export * from "./PromoCodeFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports